import React from 'react';

export const QuestionText = ({question, preAnswer, response}) => {

    return <div className={"QuestionElement QuestionTextLine"}>
        <div className={"Question"}>{ question }</div>
        <textarea className={"TextInput"} rows={20} defaultValue={preAnswer} onChange={ value => response(value.target.value) } />
    </div>
}